export default {
      id: "ic_confirm_error-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_confirm_error-usage",
      toString: function () {
        return this.url;
      }
    }